<script>
import { apiSecond } from '@/boot/axios'
import Region from '@/components/components/Inputs/region'
import AqEmpty from '@/components/aqua/AqEmpty.vue'
import AqPageHeader from '@/components/aqua/AqPageHeader.vue'
import AqStatus from '@/components/aqua/AqStatus.vue'
import AquaSelect from '@/views/account/reporting/aqua/AquaSelect.vue'

export default {
	name: 'ZpmIndex',
	components: {
		Region,
		AqEmpty,
		AqPageHeader,
		AqStatus,
		AquaSelect,
	},
	data() {
		const statusOptions = [
			{ value: '', label: this.$t('filters.status_all') },
			{ value: 'active', label: this.$t('zpm.status_active') },
			{ value: 'inactive', label: this.$t('zpm.status_inactive') },
			{ value: 'suspended', label: this.$t('zpm.status_suspended') },
			{ value: 'terminated', label: this.$t('zpm.status_terminated') },
		]
		return {
			statusOptions,
			selectedStatus:
				statusOptions.find((o) => o.value === (this.$route.query.status || '')) || statusOptions[0],
			activityTypes: [],
			selectedActivityType: null,
			regionId: this.$route.query.region_id ? Number(this.$route.query.region_id) : null,
			archived: this.$route.query.archived === '1',
			headers: [
				{ text: this.$t('headers.zpm_nikad'), value: 'zpm_nikad', width: '190px' },
				{ text: this.$t('labels.subjectName'), value: 'title' },
				{ text: this.$t('headers.status'), value: 'status', width: '140px' },
				{ text: this.$t('aqua.ui.zpm.remainder_of_capacity'), value: 'total_capacity', width: '150px' },
				{ text: '', value: 'action', align: 'end', sortable: false, width: '100px' },
			],
			list: [],
			totals: 0,
			loading: false,
			filters: {
				bin: this.$route.query.bin || '',
				zpm_nikad: this.$route.query.zpm_nikad || '',
				title: this.$route.query.title || '',
			},
			errorMessage: {
				status: null,
				text: null,
			},
			options: {
				page: Number(this.$route?.query?.page || 1),
				itemsPerPage: Number(this.$route?.query?.per_page || 10),
			},
		}
	},
	computed: {
		query() {
			return this.$route.query
		},
		canManage() {
			return this.$store.getters.userPermission(['change_zpm'])
		},
		regionalConfines() {
			const user = this.$store.state.userObject
			if (!['tir', 'mio'].includes(user?.role?.name)) return []
			return (user.regions || []).map((region) => ({ id: region.region_id }))
		},
		statusSelectOptions() {
			return this.statusOptions.map((option) => ({ value: option.value, text: option.label }))
		},
		activitySelectOptions() {
			return [
				{ value: null, text: this.$t('aqua.ui.zpm.activity_all') },
				...this.activityTypes.map((type) => ({ value: type.id, text: this.activityTypeLabel(type) })),
			]
		},
		hasFilters() {
			const query = this.$route.query
			return ['bin', 'zpm_nikad', 'title', 'status', 'activity_type_id', 'region_id', 'archived'].some((key) => query[key])
		},
	},
	watch: {
		query: {
			handler() {
				this.apiGetZpm()
			},
			immediate: true,
		},
		options: {
			handler(newOptions) {
				if (
					this.$route.query.page != newOptions.page ||
					this.$route.query.per_page != newOptions.itemsPerPage
				) {
					this.$router.replace({
						query: {
							...this.$route.query,
							page: newOptions.page,
							per_page: newOptions.itemsPerPage,
							filterTime: new Date().getTime(),
						},
					})
				}
			},
			deep: true,
		},
		'$route.query.page'(newPage) {
			if (newPage && this.options.page !== Number(newPage)) {
				this.options.page = Number(newPage)
			}
		},
		'$route.query.per_page'(newPerPage) {
			if (newPerPage && this.options.itemsPerPage !== Number(newPerPage)) {
				this.options.itemsPerPage = Number(newPerPage)
			}
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	beforeMount() {
		this.loadActivityTypes()
	},
	methods: {
		onOptionsUpdate(newOptions) {
			this.options.page = newOptions.page
			this.options.itemsPerPage = newOptions.itemsPerPage
		},
		setStatus(value) {
			this.selectedStatus = this.statusOptions.find((option) => option.value === value) || this.statusOptions[0]
		},
		setActivityType(value) {
			this.selectedActivityType = this.activityTypes.find((type) => type.id === value) || null
		},
		remainderPercent(item) {
			const total = Number(item.total_capacity)
			if (!total) return 0
			return Math.round((Number(item.total_remainder || 0) / total) * 100)
		},
		formatNum(value) {
			if (value === null || value === undefined || value === '') return '—'
			const number = Number(value)
			return Number.isNaN(number) ? value : number.toLocaleString('ru-RU', { maximumFractionDigits: 3 })
		},
		activityTitle(item) {
			return (this.$i18n.locale === 'kz' && item.activity_type_title_kz) || item.activity_type_title || item.activity_type || ''
		},
		openRecord(item) {
			this.$router.push({ path: '/' + this.$i18n.locale + '/account/zpm/' + item.id, query: { page: this.$route.query.page || 1 } })
		},
		statusLabel(status) {
			if (!status) return '-'
			const key = 'zpm.status_' + status
			return this.$te(key) ? this.$t(key) : status
		},
		formatDate(date) {
			if (!date) return '-'
			const parts = String(date).slice(0, 10).split('-')
			if (parts.length !== 3) return date
			return `${parts[2]}.${parts[1]}.${parts[0]}`
		},
		search() {
			this.$router.replace({
				query: {
					...this.$route.query,
					page: 1,
					bin: this.filters.bin || undefined,
					zpm_nikad: this.filters.zpm_nikad || undefined,
					title: this.filters.title || undefined,
					status: this.selectedStatus?.value || undefined,
					activity_type_id: this.selectedActivityType?.id || undefined,
					region_id: this.regionId || undefined,
					archived: this.archived ? '1' : undefined,
					filterTime: new Date().getTime(),
				},
			})
		},
		resetFilters() {
			this.filters = { bin: '', zpm_nikad: '', title: '' }
			this.selectedStatus = this.statusOptions[0]
			this.selectedActivityType = null
			this.regionId = null
			this.archived = false
			this.search()
		},
		async loadActivityTypes() {
			try {
				const { data } = await apiSecond.get('v1/zpm/activity-types')
				this.activityTypes = data.data || []
				this.selectedActivityType =
					this.activityTypes.find((type) => type.id === Number(this.$route.query.activity_type_id)) || null
			} catch (error) {
				this.catchError(error)
			}
		},
		activityTypeLabel(type) {
			return this.$i18n.locale === 'kz' && type.title_kz ? type.title_kz : type.title
		},
		catchError(error) {
			if (error?.response?.status == 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			}
			if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error.response.data.error_message
				this.$router.push('/' + this.$i18n.locale + '/login')
			}
			if (error?.response?.status == 422) {
				this.errorMessage.status = 422
				this.errorMessage.text = error.response.data.message || error.response.data.error_message
			}
			if (error?.response?.status == 403) {
				this.errorMessage.status = 403
				this.errorMessage.text = error?.response?.data?.message
			}
		},
		async apiGetZpm() {
			try {
				this.loading = true
				const params = {
					page: this.$route?.query?.page || 1,
					per_page: this.$route?.query?.per_page || 10,
				}
				if (this.$route.query.bin) params.bin = this.$route.query.bin
				if (this.$route.query.zpm_nikad) params.zpm_nikad = this.$route.query.zpm_nikad
				if (this.$route.query.title) params.title = this.$route.query.title
				if (this.$route.query.status) params.status = this.$route.query.status
				if (this.$route.query.activity_type_id) params.activity_type_id = this.$route.query.activity_type_id
				if (this.$route.query.region_id) params.region_id = this.$route.query.region_id
				if (this.$route.query.archived === '1') params.archived = 1

				const response = await apiSecond.get('v1/zpm', { params })

				if (response?.data?.data) {
					this.list = response.data.data
					this.totals = response.data.total
				}
			} catch (error) {
				this.catchError(error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<template>
	<div
		class="wrap__content aq-page"
		v-bind:class="{
			'wrap__content--preloader': !$store.state.userObject || !$store.getters.userPermission,
		}"
	>
		<v-preloader
			v-if="!$store.getters.userPermission || !$store.state.userObject"
			:message="errorMessage"
		></v-preloader>

		<div v-else class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['Zpm']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content aq-shell">
							<AqPageHeader
								:title="$t('sidebar.zpm')"
								:eyebrow="$t('aqua.ui.grown.eyebrow')"
								:subtitle="$t('aqua.ui.zpm.list_hint')"
							>
								<template v-if="totals" #meta>
									<span class="aq-meta">{{ $t('aqua.ui.zpm.found', { count: totals }) }}</span>
								</template>
								<template v-if="canManage" #actions>
									<router-link
										:to="{
											path: '/' + $i18n.locale + '/account/zpm/create',
											query: { page: $route.query.page || 1 },
										}"
										class="aq-btn aq-btn--primary"
									>
										<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
											<path d="M12 5v14M5 12h14" />
										</svg>
										{{ $t('button.add_zpm') }}
									</router-link>
								</template>
							</AqPageHeader>

							<form class="aq-card aq-filters" @submit.prevent="search">
								<div class="aq-filters__grid">
									<label class="aq-filters__field">
										<span>{{ $t('headers.iin_bin') }}</span>
										<input v-model="filters.bin" type="text" inputmode="numeric" name="filter_bin" class="aq-input" maxlength="15" />
									</label>
									<label class="aq-filters__field">
										<span>{{ $t('headers.zpm_nikad') }}</span>
										<input v-model="filters.zpm_nikad" type="text" name="filter_zpm_nikad" class="aq-input" />
									</label>
									<label class="aq-filters__field">
										<span>{{ $t('zpm.search_title') }}</span>
										<input v-model="filters.title" type="text" name="filter_title" class="aq-input" />
									</label>
									<div class="aq-filters__field">
										<span>{{ $t('headers.status') }}</span>
										<AquaSelect :value="selectedStatus.value" :options="statusSelectOptions" @change="setStatus" />
									</div>
									<div class="aq-filters__field">
										<span>{{ $t('zpm.activity_type_id') }}</span>
										<AquaSelect
											:value="selectedActivityType ? selectedActivityType.id : null"
											:options="activitySelectOptions"
											@change="setActivityType"
										/>
									</div>
									<div class="aq-filters__field aq-legacy">
										<span>{{ $t('inputs.region') }}</span>
										<region
											:modelValue="regionId"
											:confinesValue="regionalConfines"
											:placeholder="$t('aqua.ui.zpm.region_all')"
											@update:modelValue="regionId = $event"
										></region>
									</div>
									<label class="aq-switch">
										<input v-model="archived" type="checkbox" class="aq-switch__input" />
										<span class="aq-switch__track" aria-hidden="true"></span>
										<span>{{ $t('aqua.ui.zpm.show_archive') }}</span>
									</label>
									<div class="aq-filters__actions">
										<button type="button" class="aq-btn aq-btn--ghost" @click.prevent.stop="resetFilters">
											{{ $t('button.clear') }}
										</button>
										<button type="submit" class="aq-btn aq-btn--primary">
											<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
												<circle cx="11" cy="11" r="6" />
												<path d="M20 20l-4.5-4.5" />
											</svg>
											{{ $t('button.find') }}
										</button>
									</div>
								</div>
							</form>

							<section class="aq-card aq-table">
								<v-data-table
									:headers="headers"
									:items="list"
									:loading="loading"
									:loading-text="$t('button.loading')"
									:no-results-text="$t('system_message.search')"
									disable-sort
									:options.sync="options"
									:server-items-length="totals"
									:footer-props="{
										'items-per-page-options': [5, 10, 20, 30, 40, 50],
									}"
									@update:options="onOptionsUpdate"
									@click:row="openRecord"
								>
									<template slot="item.zpm_nikad" slot-scope="{ item }">
										<router-link
											:to="{
												path: '/' + $i18n.locale + '/account/zpm/' + item.id,
												query: { page: $route.query.page || 1 },
											}"
											class="aq-table__link aq-table__code"
											@click.native.stop
										>
											{{ item.zpm_nikad || '—' }}
										</router-link>
										<span class="aq-table__muted">{{ formatDate(item.start_date) }} – {{ formatDate(item.end_date) }}</span>
									</template>
									<template slot="item.title" slot-scope="{ item }">
										<span class="aq-table__strong">{{ item.title }}</span>
										<span class="aq-table__muted">{{ item.bin }}<template v-if="item.region_title"> · {{ item.region_title }}</template></span>
										<span v-if="activityTitle(item)" class="aq-table__muted">{{ activityTitle(item) }}</span>
									</template>
									<template slot="item.status" slot-scope="{ item }">
										<div class="aq-table__badges">
											<AqStatus :value="item.status" :label="statusLabel(item.status)" />
											<AqStatus v-if="item.archived_at" tone="neutral" :label="$t('zpm.archived')" />
												<AqStatus v-if="item.transferred_at" tone="info" :label="$t('aqua.ui.zpm.in_warehouse')" />
										</div>
									</template>
									<template slot="item.total_capacity" slot-scope="{ item }">
										<div class="aq-capacity-cell">
											<span>
												<strong>{{ formatNum(item.total_remainder) }}</strong>
												/ {{ formatNum(item.total_capacity) }} {{ $t('aqua.ui.zpm.unit') }}
											</span>
											<span
												class="aq-bar"
												:class="{ 'aq-bar--low': remainderPercent(item) < 20 }"
												role="progressbar"
												:aria-valuenow="remainderPercent(item)"
												aria-valuemin="0"
												aria-valuemax="100"
											>
												<span :style="{ width: remainderPercent(item) + '%' }"></span>
											</span>
										</div>
									</template>
									<template slot="item.action" slot-scope="{ item }">
										<div class="aq-table__actions">
											<router-link
												v-if="!item.transferred_at && !item.archived_at && canManage"
												:to="{
													path: '/' + $i18n.locale + '/account/zpm/' + item.id + '/edit',
													query: { page: $route.query.page || 1 },
												}"
												class="aq-btn aq-btn--ghost aq-btn--icon"
												:aria-label="$t('tooltip.edit')"
												:title="$t('tooltip.edit')"
												@click.native.stop
											>
												<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
													<path d="M4 20h4L19 9l-4-4L4 16z" />
												</svg>
											</router-link>
											<router-link
												:to="{
													path: '/' + $i18n.locale + '/account/zpm/' + item.id,
													query: { page: $route.query.page || 1 },
												}"
												class="aq-btn aq-btn--ghost aq-btn--icon"
												:aria-label="$t('tooltip.look')"
												:title="$t('tooltip.look')"
												@click.native.stop
											>
												<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
													<path d="M9 5l7 7-7 7" />
												</svg>
											</router-link>
										</div>
									</template>
									<template #no-data>
										<AqEmpty
											:title="hasFilters ? $t('aqua.ui.zpm.empty_filtered') : $t('aqua.ui.zpm.empty_title')"
											:text="hasFilters ? $t('aqua.ui.zpm.empty_filtered_text') : $t('aqua.ui.zpm.empty_text')"
										>
											<button v-if="hasFilters" type="button" class="aq-btn" @click="resetFilters">{{ $t('button.clear') }}</button>
										</AqEmpty>
									</template>
								</v-data-table>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.aq-shell {
	background: var(--aq-bg);
}
.aq-meta {
	color: var(--aq-muted);
	font-size: 14px;
}
.aq-filters {
	padding: 20px 24px;
}
.aq-filters__grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
	align-items: end;
	gap: 14px 16px;
}
.aq-filters__field {
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
	margin: 0;
}
.aq-filters__field > span {
	color: var(--aq-ink-2);
	font-size: 13px;
	font-weight: 500;
}
.aq-filters__field ::v-deep .aqua-select {
	width: 100%;
}
.aq-filters__field ::v-deep .aqua-select__control {
	height: 44px;
	border-color: var(--aq-border-strong);
	border-radius: 10px;
	transition: border-color 0.2s var(--aq-ease);
}
.aq-filters__field ::v-deep .aqua-select__control:hover {
	border-color: var(--aq-primary);
}
.aq-legacy ::v-deep .multiselect__tags {
	min-height: 44px;
	padding-top: 10px;
	border: 1px solid var(--aq-border-strong) !important;
	border-radius: 10px;
	transition: border-color 0.2s var(--aq-ease);
}
.aq-legacy ::v-deep .multiselect__tags:hover,
.aq-legacy ::v-deep .multiselect--active .multiselect__tags {
	border-color: var(--aq-primary) !important;
}
.aq-legacy ::v-deep .multiselect__content-wrapper {
	min-width: 100%;
	width: max-content;
	max-width: 360px;
}
.aq-legacy ::v-deep .multiselect__option {
	white-space: normal;
}
.aq-legacy ::v-deep .input-wrapper,
.aq-legacy ::v-deep .input-body {
	margin: 0;
}
.aq-switch {
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 10px;
	min-height: 44px;
	margin: 0;
	color: var(--aq-ink);
	font-size: 15px;
	cursor: pointer;
}
.aq-switch__input {
	position: absolute;
	opacity: 0;
	pointer-events: none;
}
.aq-switch__track {
	position: relative;
	flex-shrink: 0;
	width: 42px;
	height: 24px;
	border-radius: 999px;
	background: var(--aq-border-strong);
	transition: background 0.2s var(--aq-ease);
}
.aq-switch__track::after {
	content: '';
	position: absolute;
	top: 3px;
	left: 3px;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: #fff;
	box-shadow: 0 1px 2px rgba(21, 29, 72, 0.2);
	transition: transform 0.2s var(--aq-ease);
}
.aq-switch__input:checked + .aq-switch__track {
	background: var(--aq-primary);
}
.aq-switch__input:checked + .aq-switch__track::after {
	transform: translateX(18px);
}
.aq-switch__input:focus-visible + .aq-switch__track {
	box-shadow: 0 0 0 3px rgba(21, 127, 238, 0.25);
}
.aq-filters__actions {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	grid-column: -2 / -1;
}
.aq-table {
	overflow: hidden;
}
.aq-table ::v-deep .v-data-table {
	background: transparent;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
	height: 46px;
	padding: 0 12px;
	border-bottom: 1px solid var(--aq-border) !important;
	background: #f7faff;
	color: var(--aq-muted) !important;
	font-size: 12px !important;
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.04em;
	text-transform: uppercase;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	height: 68px;
	padding: 10px 12px;
	border-bottom: 1px solid var(--aq-border) !important;
	color: var(--aq-ink);
	font-size: 14px;
	vertical-align: middle;
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__empty-wrapper) {
	cursor: pointer;
	transition: background 0.15s var(--aq-ease);
}
.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__empty-wrapper):hover {
	background: #f7faff !important;
}
.aq-table ::v-deep .v-data-table__empty-wrapper:hover {
	background: transparent !important;
}
.aq-table ::v-deep .v-data-footer {
	padding: 6px 12px;
	border-top: 0;
	color: var(--aq-muted);
}
.aq-table__link {
	display: block;
	color: var(--aq-ink);
	font-weight: 600;
	text-decoration: none;
}
.aq-table__link:hover,
.aq-table__link:focus-visible {
	color: var(--aq-primary);
	outline: none;
}
.aq-table__code {
	font-family: ui-monospace, 'SFMono-Regular', Consolas, monospace;
	font-size: 14px;
	letter-spacing: 0.02em;
}
.aq-table__strong {
	display: block;
	font-weight: 600;
	line-height: 1.35;
}
.aq-table__muted {
	display: block;
	margin-top: 2px;
	color: var(--aq-muted);
	font-size: 13px;
}
.aq-table__badges {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 6px;
}
.aq-table__actions {
	display: flex;
	justify-content: flex-end;
	gap: 2px;
}
.aq-capacity-cell {
	display: flex;
	flex-direction: column;
	gap: 6px;
	white-space: nowrap;
	color: var(--aq-muted);
	font-size: 13px;
}
.aq-capacity-cell strong {
	color: var(--aq-ink);
	font-size: 15px;
}
.aq-bar {
	display: block;
	height: 6px;
	border-radius: 999px;
	background: #edf2f8;
	overflow: hidden;
}
.aq-bar span {
	display: block;
	height: 100%;
	border-radius: inherit;
	background: var(--aq-success);
	transition: width 0.3s var(--aq-ease);
}
.aq-bar--low span {
	background: #e39a1b;
}
.aq-btn--icon {
	width: 36px;
	min-height: 36px;
	padding: 0;
}
@media (max-width: 1280px) {
	.aq-table ::v-deep table > thead > tr > th:nth-child(5),
	.aq-table ::v-deep table > tbody > tr > td:nth-child(5) {
		display: none;
	}
	.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
	.aq-table ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
		padding-right: 8px;
		padding-left: 8px;
		width: auto !important;
		min-width: 0 !important;
	}
	.aq-capacity-cell {
		min-width: 120px;
	}
}
@media (max-width: 768px) {
	.aq-filters {
		padding: 16px;
	}
	.aq-filters__actions {
		grid-column: 1 / -1;
	}
}
</style>
